import { Box, css } from '@mui/material'
import styled from '@emotion/styled'

export const Buttons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    margin-top: 32px;
    justify-content: flex-end;

    @media (max-width: ${theme.screenSizes.laptop}) {
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-end;
      gap: 16px;

      > button {
        flex: 1 1 0;
        min-width: 0;
      }

      > button:only-child {
        flex-basis: auto;
        width: 100% !important;
      }

      .button-text {
        justify-content: center;
        text-align: center;
        font-size: 14px;
        line-height: 18px;
      }
    }
  `}
`
